<ui-dialog
    size="small"
    header="employees.leaveOfAbsence.retroactiveHeader"
    [open]="showRetroactiveModal"
    (closing)="showRetroactiveModal = false"
    primaryButtonLabel="{{ 'yesConfirm' | translate }}"
    (primaryButtonPressed)="
        backDatedLeaveOfAbsenceStartDateAffirmed = true;
        showRetroactiveModal = false;
        appSteps.setStep(appSteps.activeStep + 1)
    "
    secondaryButtonLabel="{{ 'cancel' | translate }}"
    [secondaryButtonType]="'ghost'"
    (secondaryButtonPressed)="showRetroactiveModal = false"
>
    <p>
        {{
            'employees.leaveOfAbsence.retroactiveDescription'
                | translate: { date: lastRecurringPayrollEndDate | appDate }
        }}
    </p>
    <ui-banner variant="info" [closable]="false">
        <p [innerHTML]="'employees.leaveOfAbsence.retroactiveInfoDescription' | appTranslate"></p>
    </ui-banner>
</ui-dialog>

<ui-dialog
    size="small"
    header="employees.leaveOfAbsence.nextStepsHeader"
    [open]="showNextStepsModal"
    (closing)="showNextStepsModal = false"
    (primaryButtonPressed)="showNextStepsModal = false; onSave()"
    primaryButtonLabel="{{ 'yesConfirm' | translate }}"
    secondaryButtonLabel="{{ 'cancel' | translate }}"
    [secondaryButtonType]="'ghost'"
    (secondaryButtonPressed)="showNextStepsModal = false"
>
    <div [innerHTML]="'employees.leaveOfAbsence.nextStepsDescription' | appTranslate"></div>
</ui-dialog>

<ui-confirmation-dialog
    #generateRoeModal
    size="small"
    header="employees.leaveOfAbsence.generateRoeHeader"
    primaryButtonLabel="{{ 'employees.leaveOfAbsence.generateRoeButtonNow' | appTranslate }}"
    secondaryButtonLabel="{{ 'employees.leaveOfAbsence.generateRoeButtonLater' | appTranslate }}"
    secondaryButtonType="ghost"
>
    <p>{{ 'employees.leaveOfAbsence.generateRoeBody' | appTranslate }}</p>
    <ui-banner variant="bulb">
        <span [innerHTML]="'employees.leaveOfAbsence.generateRoeBanner' | appTranslate"></span>
    </ui-banner>
</ui-confirmation-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-steps
        #appSteps
        [steps]="[informationStep, taskStep, reviewStep]"
        [beforeNext]="shouldMoveToNextStep"
        (onPrimary)="onConfirm()"
        [labels]="{ primary: 'employees.leaveOfAbsence.completeButton' }"
    >
        <ui-banner
            *ngIf="appSteps.steps[appSteps.activeStep] === reviewStep && showRetroactiveDialog"
            variant="warning"
            [closable]="false"
        >
            <p>{{ 'employees.leaveOfAbsence.retroactiveDateWarning' | appTranslate }}</p>
        </ui-banner>

        <app-step
            #informationStep
            step="employees.leaveOfAbsence.informationStep"
            [stepForm]="informationForm"
            title="{{ 'employees.leaveOfAbsence.informationHeader' | appTranslate }}"
        >
            <app-leave-of-absence-information-form
                [leaveOfAbsenceTypes]="leaveOfAbsenceTypes"
                [leaveOfAbsence]="leaveOfAbsence"
                [mode]="mode"
                [employeeActiveOnPayroll]="employee.activeOnPayroll()"
                (leaveOfAbsenceStartDateChange)="leaveOfAbsenceStartDateChange($event)"
                #informationForm
            >
            </app-leave-of-absence-information-form>
        </app-step>

        <app-step
            #taskStep
            [stepForm]="taskForm"
            step="{{ 'employees.leaveOfAbsence.tasksAndRemindersStep' | appTranslate }}"
            title="{{ 'employees.leaveOfAbsence.tasksHeader' | appTranslate }}"
        >
            <app-leave-of-absence-task-form
                [(selectedTaskTemplates)]="selectedTaskTemplates"
                [employee]="employee"
                #taskForm
            ></app-leave-of-absence-task-form>
        </app-step>

        <app-step
            #reviewStep
            [stepForm]="reviewForm"
            step="{{ 'employees.leaveOfAbsence.reviewStep' | appTranslate }}"
            title="{{ 'employees.leaveOfAbsence.reviewHeader' | appTranslate }}"
        >
            <app-leave-of-absence-review
                #reviewForm
                [employee]="employee"
                [leaveOfAbsence]="leaveOfAbsence"
                [selectedTaskTemplates]="selectedTaskTemplates"
            ></app-leave-of-absence-review>
        </app-step>
    </app-steps>
</div>
